import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { UrduInput } from "../../../Components/Shared/UrduInput";

function ModalAddBuyPlan({ isOpen, onClose, onSubmit, editPlan }) {
  const [formData, setFormData] = useState({
    name: "",
    name_ur: "",
    upto_5_marla: "",
    from_5_to_12_marla: "",
    from_8_to_12_marla: "",
    from_12_to_18_marla: "",
    from_18_to_25_marla: "",
    above_25_marla: "",
  });

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        name: "",
        name_ur: "",
        upto_5_marla: "",
        from_5_to_12_marla: "",
        from_8_to_12_marla: "",
        from_12_to_18_marla: "",
        from_18_to_25_marla: "",
        above_25_marla: "",
      });
    } else if (editPlan) {
      setFormData({
        name: editPlan.name || "",
        name_ur: editPlan.name_ur || "",
        upto_5_marla: editPlan.upto_5_marla || "",
        from_5_to_12_marla: editPlan.from_5_to_12_marla || "",
        from_8_to_12_marla: editPlan.from_8_to_12_marla || "",
        from_12_to_18_marla: editPlan.from_12_to_18_marla || "",
        from_18_to_25_marla: editPlan.from_18_to_25_marla || "",
        above_25_marla: editPlan.above_25_marla || "",
      });
    }
  }, [isOpen, editPlan]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, editPlan?.id);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg w-2/3 max-h-[80vh] overflow-auto relative">
        <button className="absolute top-4 right-4 text-black" onClick={onClose}>
          <IoClose className="w-6 h-6" />
        </button>

        <h3 className="text-xl font-bold mt-2">
          {editPlan ? "Edit Plan" : "Add Plan"}
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label className="block">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter name"
              />
              <UrduInput
                label="نام"
                name="name_ur"
                value={formData.name_ur}
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="block">Up To 5 Marla</label>
              <input
                type="number"
                name="upto_5_marla"
                value={formData.upto_5_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
            <div>
              <label className="block">From 5 to 12 Marla</label>
              <input
                type="number"
                name="from_5_to_12_marla"
                value={formData.from_5_to_12_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
            <div>
              <label className="block">From 8 to 12 Marla</label>
              <input
                type="number"
                name="from_8_to_12_marla"
                value={formData.from_8_to_12_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
            <div>
              <label className="block">From 12 to 18 Marla</label>
              <input
                type="number"
                name="from_12_to_18_marla"
                value={formData.from_12_to_18_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
            <div>
              <label className="block">From 18 to 25 Marla</label>
              <input
                type="number"
                name="from_18_to_25_marla"
                value={formData.from_18_to_25_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
            <div>
              <label className="block">Above 25 Marla</label>
              <input
                type="number"
                name="above_25_marla"
                value={formData.above_25_marla}
                onChange={handleChange}
                className="w-full border px-3 py-2 mt-2 rounded-md"
                placeholder="Enter value"
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              className="btn btn-reset-filter justify-center"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn justify-center ${
                editPlan ? "btn-edit text-white" : "btn-primary"
              }`}
            >
              {editPlan ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalAddBuyPlan;
